<template>
  <div>
    <div class="card">
      <!---内容变更--->
      <div class="section">
        <div class="section-title">
          <base-section-title title="内容变更" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="changeInfo.changeInfo || {}"
            :option="contentOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:competitionStart="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 元</span>
              <money-in-cn :money="value" />
            </template>
            <template v-slot:offerRange="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 元</span>
              <money-in-cn :money="value" />
            </template>
          </jczh-descriptions>
        </div>
      </div>

      <!---变更公告--->
      <div class="section">
        <div class="section-title">
          <base-section-title title="变更公告" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="changeInfo.notice || {}"
            :option="noticeOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:noticeContent>
              <u-editor disabled :value="content" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import MoneyInCn from '@/components/common/MoneyInCn'

import {
  competeWhetherOpenDict,
  competeMethodDict
} from '@/dictionary/project/compete'
import { noticeReleaseStatusDict } from '@/dictionary/project/common'

// api接口
import { getCompeteNewestChangeInfoApi } from '@/api/procure/compete'

import { strToThousands } from '@/utils/utils'
export default {
  components: {
    BaseSectionTitle,
    UEditor,
    MoneyInCn
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      competeWhetherOpenDict,
      competeMethodDict,

      changeInfo: {},
      contentOptions: [
        {
          label: '报名截止时间',
          prop: 'signUpEndTime',
          isNormMinute: true
        },
        {
          label: '竞价开始时间',
          prop: 'competitionStartTime',
          isNormMinute: true
        },
        {
          label: '竞价方式',
          prop: 'competitionMethod',
          filter: value => (competeMethodDict.translate(value)?.label || '-')
        },
        {
          label: '起始价',
          prop: 'competitionStart',
          slotName: 'competitionStart'
        },
        {
          label: '竞价时长',
          prop: 'competitionTime',
          filter: value => `${value} 分钟`
        },
        {
          label: '超时竞价延长',
          prop: 'extendTime',
          filter: value => `${value} 分钟`
        },
        {
          label: '报价最小幅度',
          prop: 'offerRange',
          slotName: 'offerRange'
        },
        {
          label: '竞价过程',
          prop: 'whetherOpen',
          filter: value =>
            (value === competeWhetherOpenDict.YES.value ? '' : '不') +
            '公开竞价公司'
        },
      ],
      noticeOptions: [
        {
          label: '发布日期',
          prop: 'publishTime',
          isNormDay: true
        },
        {
          label: '发布状态',
          prop: 'releaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '变更公告标题',
          prop: 'noticeTitle'
        },
        {
          label: '变更公告内容',
          prop: 'noticeContent',
          slotName: 'noticeContent'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },
    content() {
      return this.changeInfo?.notice?.noticeContent || ''
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler: function(val) {
        if (val) {
          this.getChangeInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,

    // 获取竞价变更信息
    getChangeInfo() {
      if (!this.orderId) return
      getCompeteNewestChangeInfoApi(this.orderId)
        .then(res => {
          this.changeInfo = res.data || {}
          this.$emit('setChangeInfo', this.changeInfo)
        })
        .catch(err => {
          this.$message.error(err.message || '获取信息失败')
        })
    }
  }
}
</script>
